import { isDate } from './type-utils';
export default function clone(obj) {
    if (obj == null || typeof obj !== 'object') {
        return obj;
    }
    let temp = null;
    if (isDate(obj)) {
        temp = new Date(obj.getTime());
    }
    else {
        temp = obj.constructor();
        for (const key in obj) {
            temp[key] = clone(obj[key]);
        }
    }
    return temp;
}
//# sourceMappingURL=clone.js.map